import script from "./DataBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataBlock.vue?vue&type=script&setup=true&lang=ts"

import "./DataBlock.vue?vue&type=style&index=0&id=b8500e12&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8500e12"]])

export default __exports__